import createVueComponent from '../createVueComponent';

const Clock9 = createVueComponent('Clock9Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 7.5 12' }],
]);

export default Clock9;
